import React from 'react';

import styles from './mobile-max-input.module.scss';
import { InnerInputProps } from '../types';
import { InputBase } from '../input-base';

const MobileMaxInput: React.FC<InnerInputProps> = (props) => {
  return <InputBase styles={styles} {...props} />;
};

export { MobileMaxInput };
